import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { DEVICE_TYPE } from '@constants/index';
import { getDevice } from '@utils/index';
import { CAL_TYPE, setDateObj } from '@features/calendar/core';
import type { IDateObj } from '@type/index';

export interface CalendarState {
  type: (typeof CAL_TYPE)[keyof typeof CAL_TYPE];
  selectedDate: IDateObj; // 선택한 날짜
  drawDate: IDateObj; // swipe/이동 버튼으로 주/월 이동 시 변경되는 날짜(화면상에 노출되진 않음)
}

const device = getDevice();
const isPc = device === DEVICE_TYPE.PC;
const initialDate = setDateObj();
const initialState: CalendarState = {
  type: isPc ? CAL_TYPE.MONTH : CAL_TYPE.WEEK,
  selectedDate: initialDate,
  drawDate: initialDate,
};

export const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    setType(state, action) {
      state.type = action?.payload;
    },
    setSelectedDate(state, action) {
      state.selectedDate = action?.payload;
    },
    setDrawDate(state, action) {
      state.drawDate = action?.payload;
    },
  },
});

export const { setType, setSelectedDate, setDrawDate } = calendarSlice.actions;

export const selectedType = (state: RootState) => state?.calendar?.type;
export const selectedSelectedDate = (state: RootState) => state?.calendar?.selectedDate;
export const selectedDrawDate = (state: RootState) => state?.calendar?.drawDate;

export default calendarSlice.reducer;
